import { inject, Injectable } from '@angular/core';

import { Observable } from 'rxjs';
import { map, tap } from 'rxjs/operators';

import { Action } from '@ngrx/store';
import { createEffect, ofType } from '@ngrx/effects';
import { BaseEffects } from '@store/base.effects';
import { RootActions } from './root.actions';

import { DialogService } from '@services/dialog/dialog.service';

@Injectable({ providedIn: 'root' })
export class RootEffects extends BaseEffects {
  private dialogService = inject(DialogService);

  showSearchDialog$: Observable<Action> = createEffect(() =>
    this.actions$.pipe(
      ofType(RootActions.showSearchDialog),
      map(() => RootActions.showDialog({ componentKey: 'SEARCH' }))
    )
  );

  showNewsletterDialog$: Observable<Action> = createEffect(() =>
    this.actions$.pipe(
      ofType(RootActions.showNewsletterDialog),
      map(() => RootActions.showDialog({ componentKey: 'NEWSLETTER' }))
    )
  );

  showWebinarDialog$: Observable<Action> = createEffect(() =>
  
    this.actions$.pipe(
      ofType(RootActions.showWebinarDialog),
      map(() => RootActions.showDialog({ componentKey: 'WEBINAR' }))
    )
  );

  showDialog$ = createEffect(
    () =>
      this.actions$.pipe(
        ofType(RootActions.showDialog),
        tap(({ componentKey }) => this.dialogService.showDialog(componentKey)),
        map(() => null)
      ),
    { dispatch: false }
  );
}
